import { render, staticRenderFns } from "./FullPageDigiTeacherDashboard.vue?vue&type=template&id=2c09a420&"
import script from "./FullPageDigiTeacherDashboard.vue?vue&type=script&lang=js&"
export * from "./FullPageDigiTeacherDashboard.vue?vue&type=script&lang=js&"
import style0 from "./FullPageDigiTeacherDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports